/* eslint-disable react/prop-types */
//import React from 'react';
import React, { useState, useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import CaixaLista from './caixalista';

import AuthUser from '../../components/AuthUser';

const CaixaIndex = ({ match }) => {

     // eslint-disable-next-line no-unused-vars
     const { verificarPermissao } = AuthUser();

     // eslint-disable-next-line no-unused-vars

     const [permissaoVer, setPermissaoVer] = useState(false);
     const [permissaoAdicionar, setPermissaoAdicionar] = useState(false);
     const [permissaoAtivar, setPermissaoAtivar] = useState(false);
     const [permissaoRemover, setPermissaoRemover] = useState(false);
 
     useEffect(() => {
 
         setPermissaoVer(verificarPermissao('CAIXA','ver'));
         setPermissaoAdicionar(verificarPermissao('CAIXA','adicionar'));
         setPermissaoAtivar(verificarPermissao('CAIXA','ativar'));
         setPermissaoRemover(verificarPermissao('CAIXA','remover'));
 
     },);
 
     return (
    <Switch>

        <Redirect exact from={`${match.url}/`}  render={(props) => <CaixaLista {...props} permissaoAdicionar={permissaoAdicionar} />} />

        <Route path={`${match.url}/caixaLista`}  render={(props) => <CaixaLista {...props} permissaoVer={permissaoVer} permissaoAtivar={permissaoAtivar} permissaoRemover={permissaoRemover} permissaoAdicionar={permissaoAdicionar} />} />

    </Switch>)
}

export default CaixaIndex